import { takeLatest, put } from 'redux-saga/effects'
import {
  USER_HYDRATE,
  USER_REQUEST,
  USER_DEV_REQUEST,
  USER_SUCCESS,
  USER_FAILURE,
  SESS_GUID_RECEIVED
} from 'actions'
import { getUserInfo, getUserInfoDev } from 'common/api/user'
import { createGuid } from 'common/api/user'
import { getValueFromCookie } from 'common/utilities'

const initialState = { auth: false, sess_guid: null }

/** ACTIONS
 --------------------------------------------------------------- */
export const userHydrate = (hydrate) => ({ type: USER_HYDRATE, hydrate })
export const getUser = () => ({ type: USER_REQUEST })
export const devUser = () => ({ type: USER_DEV_REQUEST })

/** REDUCERS
 --------------------------------------------------------------- */
export const userReducers = (state = initialState, action) => {
  switch (action.type) {
    case USER_HYDRATE: {
      const { hydrate } = action
      return { ...state, ...hydrate, auth: true }
    }

    case USER_SUCCESS: {
      const { user } = action
      return { ...state, ...user, auth: true }
    }

    case USER_FAILURE: {
      return {
        ...state,
        auth: false // force auth to false
      }
    }

    default:
      return state
  }
}

/** SAGAS :: WATCHERS
 --------------------------------------------------------------- */
export const userSagas = [
  takeLatest(USER_REQUEST, userRequest),
  takeLatest(USER_DEV_REQUEST, userDevRequest)
]

/** SAGA :: RESPONDERS
 --------------------------------------------------------------- */
function* userRequest() {
  try {
    const sess_guid = yield checkSessGuid()
    const user = yield fetchUserData()

    if (sess_guid) yield put({ type: SESS_GUID_RECEIVED, sess_guid })
    if (user) return yield put({ type: USER_SUCCESS, user: user })

    // If we don't have a user, we assume they have not authenticated
    yield put({ type: USER_FAILURE, error: 'User not authenticated' })
  } catch (error) {
    yield put({ type: USER_FAILURE, error })
  }
}

// This is very similar to above but uses the client side login shape.
// It is a stop gap that will be removed once auth is revamped on the backend
function* userDevRequest() {
  try {
    const { user } = yield getUserInfoDev()
    if (user) return yield put({ type: USER_SUCCESS, user: user })

    // If we don't have a user, we assume they have not authenticated
    yield put({ type: USER_FAILURE, error: 'User not authenticated' })
  } catch (error) {
    yield put({ type: USER_FAILURE, error })
  }
}

/** ASYNC Functions
 --------------------------------------------------------------- */
export async function fetchUserData(cookie) {
  try {
    const response = await getUserInfo(cookie)
    const { user } = response
    return user
  } catch (error) {
    return false
  }
}

/**
 * getSessGuid will get a valid sess_guid from either a cookie or the server,
 * if it gets one from the server, it will also store that guid in a cookie
 * @return {string} sess_guid
 */
export async function checkSessGuid(cookie, res) {
  // Get sess_guid
  const sessGuidSSR = getValueFromCookie('sess_guid', cookie)
  const sess_guid = sessGuidSSR || (await createGuid())

  if (!sessGuidSSR) {
    res.cookie('sess_guid', sess_guid, {
      domain: 'getpocket.com',
      samesite: 'lax',
      expires: 'Wed, 24-Aug-2033 19:33:21 GMT',
      path: '/',
      maxAge: 473040000,
      httpOnly: true
    })
  }

  return sess_guid
}
